import { makeAutoObservable, reaction, action } from "mobx";
import config, { afterExtendConfig } from "../../config";

const darkModeQuery = window.matchMedia("(prefers-color-scheme: dark)");

export function changeColorScheme({ darkMode }) {
  if (!config.FF_DARK_MODE) darkMode = false;
  document.body.classList.remove("color-scheme-light");
  document.body.classList.remove("color-scheme-dark");
  if (darkMode) {
    document.body.classList.add("color-scheme-dark");
  } else {
    document.body.classList.add("color-scheme-light");
  }
}

// initialize color scheme to system default before prefs load.
changeColorScheme({ darkMode: darkModeQuery.matches });
// Disable on config load.
afterExtendConfig(() => changeColorScheme({ darkMode: darkModeQuery.matches }));

export class ColorSchemeStore {
  appStore;
  systemDarkMode = darkModeQuery.matches;

  constructor({ appStore }) {
    makeAutoObservable(this);
    this.appStore = appStore;
    darkModeQuery.addEventListener(
      "change",
      action(async () => {
        this.systemDarkMode = darkModeQuery.matches;
      }),
    );
    reaction(
      () => this.darkMode,
      (darkMode) => {
        changeColorScheme({ darkMode });
      },
    );
  }

  toString() {
    return this.darkMode ? "darkMode" : "lightMode";
  }

  get darkMode() {
    const prefDarkMode =
      config.FF_DARK_MODE &&
      this.appStore.prefs?.userPreferences?.client?.darkMode;
    return prefDarkMode ?? this.systemDarkMode;
  }

  get theme() {
    const cssVars = [
      "background",
      "neutral1_2",
      "neutral1_4",
      "neutral2",
      "neutral2_2",
      "neutral2_3",
      "neutral3",
      "neutral4",
      "color",
    ];
    const theme = cssVars.reduce((theme, cssVar) => {
      theme[cssVar] = getComputedStyle(document.body).getPropertyValue(
        `--${cssVar}`,
      );
      return theme;
    }, {});
    return theme;
  }
}
